import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import SubjectAutocomplete from "./SubjectAutocomplete";
import './SubjectsInput.scss';

interface Subject {
    subject: string;
    isPrimary: boolean;
    isClassroom?: boolean;
}

interface IFormInput {
    teacherName: string;
    subjects: Subject[];
    username: string;
    password: string;
}

const SubjectsInput = () => {
    const { control,formState: { errors } } = useFormContext<IFormInput>();
    const { fields } = useFieldArray({
        control,
        name: 'subjects',
    });

    const findFirstSubjectError = () => {
        if(errors.subjects?.message && fields.every(value=>value.subject==='')){
            return errors?.subjects?.message;
        }
        for (let i = 0; i < fields.length; i++) {
            if (errors.subjects?.[i]?.subject?.message) {
                return errors?.subjects?.[i]?.subject?.message;
            }
        }
        return null; // Return null if no errors found
    };

    const commonError = findFirstSubjectError();

    return (
        <div className="subjectsInput">
            {fields.map((item, index) => {
                const placeholder = item.isPrimary ? "Subject" : item.isClassroom ? "Add" : "Add other";

                return (
                    <div
                        key={item.id}
                        className={
                            item.isPrimary
                                ? `primarySubjectField`
                                : item?.isClassroom
                                ? `classroomSubjectField`
                                : `secondarySubjectField`
                        }
                    >
                        <Controller
                            control={control}
                            name={`subjects.${index}.subject`}
                            defaultValue={item.subject}
                            render={({ field: { onChange, value, ref } }) => (
                                <SubjectAutocomplete
                                    value={value}
                                    onChange={onChange}
                                    placeholder={placeholder}
                                    ref={ref}
                                />
                            )}
                        />
                    </div>
                );
            })}

            {commonError && (
                <span className="error-message">{commonError}</span>
            )}
        </div>
    );
};

export default SubjectsInput;
